var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { ListGroupItem } from 'reactstrap';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var CordataListGroupItem = function CordataListGroupItem(_ref) {
  var children = _ref.children,
    action = _ref.action,
    props = _objectWithoutProperties(_ref, ['children', 'action']);
  var classes = classnames({
    'd-flex justify-content-between align-items-center': !!action
  });
  return React.createElement(ListGroupItem, _extends({
    className: classes,
    action: action
  }, props), action ? React.createElement(React.Fragment, null, React.createElement('span', null, children), React.createElement(FontAwesomeIcon, {
    icon: 'chevron-right',
    className: 'text-muted'
  })) : children);
};
CordataListGroupItem.propTypes = {
  children: PropTypes.node.isRequired,
  action: PropTypes.bool
};
CordataListGroupItem.defaultProps = {
  action: false
};
export default CordataListGroupItem;